import { render, staticRenderFns } from "./QrScanImport2fa.vue?vue&type=template&id=10915d52&"
import script from "./QrScanImport2fa.vue?vue&type=script&lang=js&"
export * from "./QrScanImport2fa.vue?vue&type=script&lang=js&"
import style0 from "./QrScanImport2fa.vue?vue&type=style&index=0&id=10915d52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports